module.exports = {
  "/": {
    "name": "root",
    "success": {
      "default": [
        "root"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/callout": {
    "name": "callout",
    "success": {
      "default": [
        "callout"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/question": {
    "name": "question",
    "success": {
      "default": [
        "question"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/follow_up": {
    "name": "follow_up",
    "success": {
      "default": [
        "follow_up"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  },
  "/thank_you": {
    "name": "thank_you",
    "success": {
      "default": [
        "thank_you"
      ]
    },
    "error": [
      "ERROR_PAGE"
    ]
  }
};